<template>
  <div class="header">
    <div class="w navi" @mouseover="modalFn(2,'big')">
      <div class="flex logo_top">
        <img style="height: 48px;" :src="imgPrefix + findTopBar.logoColor" alt="" />
        <div class="flex top_r">
          <!-- <div @click="toSchool">湖北民族大学官网</div> -->
          <template v-if="userId">
            <!-- <div class="line_ver"></div> -->
             <a-dropdown>
               <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                 {{supUserName}}<a-icon type="down" />
               </a>
               <a-menu slot="overlay">
                 <a-menu-item>
                   <a href="javascript:;" style="color: #2c3e50;" @click.stop="logout">退出登录</a>
                 </a-menu-item>
               </a-menu>
             </a-dropdown>
          </template>
          <!-- <div v-else @click.stop="loginFn">登录</div> -->
        </div>
      </div>
      <div class="flex nav_ul" @mouseover="modalFn(2,'big')">
        <div
          :class="index == naviIndex ? 'navi_li line_class' : 'navi_li'"
          v-for="(item, index) in naviArr"
          :key="index"
          @click="changeUrl(item.link, index, item)"
          @mouseover.stop="handleMouseOver(item.link, index, item)"
        >
          <div class="flex">
              <img :src="index == naviIndex ? item.pictrue : item.pictrue2" alt="" style="margin-right: 6px;">
              <div style="font-size: 18px;">{{ item.name }}</div>
            </div>
        </div>
      </div>
    </div>
    <!-- 部门弹窗 -->
    <div class="w" @mouseover="modalFn(1,'mask')" @mouseleave="modalFn(2,'big')">
      <Department class="dept_modal" v-if="ifShowDept" @close="close" :naviArr="naviArr" />
    </div>
  </div>
</template>

<script>
import imgPrefix from "../../utils/imgPrefix";
import Department from "../components/Department.vue";
import { findNavApi, findTopBarApi,logout } from "../api/index";

import Vue from 'vue';
const EventBus = new Vue();

export default {
  components: { Department },
  data() {
    return {
      // "首页", "主题专区", "服务大厅", "三张清单"
      naviArr: [],
      history: ["一卡通", "请假", "奖助学金"],
      naviIndex: "-1",
      naviId: "",
      findTopBar: {},
      imgPrefix,
      userId:'',
      supUserName:'',
      ifShowDept: false,
      type: ''
    };
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route(to, from) {
      let naviId = sessionStorage.getItem("naviId");
      let serviceManageId = this.$route.query.serviceManageId;
      this.naviId = '';
      if(this.$route.query.naviId){
        this.naviId = this.$route.query.naviId || naviId;
        if(this.naviArr.length>0){
          this.naviArr.forEach((item, idx) => {
            if (item.id == this.naviId) {
              this.naviIndex = idx;
            }
          });
        }
      }else if(serviceManageId){
        this.naviIndex = this.$route.query.index;
      }
      
    },
  },
  created() {
    // 获取登录后的userId
    this.userId = sessionStorage.getItem('userId');
    // 获取登录信息
    let info = sessionStorage.getItem('ly-portal-affairs-ui-userLogin');
    if(sessionStorage.getItem('ly-portal-affairs-ui-userLogin')){
      info = JSON.parse(info)
      // console.log(info);
      this.supUserName = info?.userName;
    }
    // 获取顶部导航
    findNavApi().then((res) => {
      // console.log(res);
      this.naviArr = res.filter((item) => {
        if(item.link == '/'){
          item.pictrue = require('../assets/icon/header/icon_index_white.png')
          // item.pictrue2 = require('../assets/icon/header/icon_index_blue.png')
          item.pictrue2 = require('../assets/icon/header/icon_index_red.svg')
        }else if(item.link == '/theme'){
          item.pictrue = require('../assets/icon/header/icon_theme_white.png')
          // item.pictrue2 = require('../assets/icon/header/icon_theme_blue.png')
          item.pictrue2 = require('../assets/icon/header/icon_theme_red.svg')
        }else if(item.link == '/serviceHall'){
          item.pictrue = require('../assets/icon/header/icon_service_white.png')
          // item.pictrue2 = require('../assets/icon/header/icon_service_blue.png')
          item.pictrue2 = require('../assets/icon/header/icon_service_red.svg')
        }else if(item.link == '/detailedList'){
          item.pictrue = require('../assets/icon/header/icon_list_white.png')
          // item.pictrue2 = require('../assets/icon/header/icon_list_blue.png')
          item.pictrue2 = require('../assets/icon/header/icon_list_red.svg')
        }
        return item.status == "1";
      });
      sessionStorage.setItem("naviArr", JSON.stringify(res));
      let naviId = sessionStorage.getItem("naviId");
      this.naviId = this.$route.query.naviId
        ? this.$route.query.naviId
        : naviId;
      this.naviArr.forEach((item, idx) => {
        if (item.id == this.naviId) {
          this.naviIndex = idx;
        }
      });
    });
    // this.findTopBar = JSON.parse(sessionStorage.getItem("findTopBar"));
    // 获取顶部栏基本信息
    findTopBarApi().then((res) => {
      // console.log(res);
      this.findTopBar = res;
      document.title = res.sysName;
      // 改变主题颜色
      const bodyStyle = document.getElementsByTagName("body")[0].style;
      bodyStyle.setProperty("--themeColor", res.topicColor);
      bodyStyle.setProperty("--themeColor1", this.hexToRgba(res.topicColor, 0.1));
      bodyStyle.setProperty("--themeColor6", this.hexToRgba(res.topicColor, 0.6));
      bodyStyle.setProperty("--themeSloganColor", res.sloganColor);

      // 改变网站图标
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = this.imgPrefix + res.webInco;
      document.getElementsByTagName("head")[0].appendChild(link);
      sessionStorage.setItem("findTopBar", JSON.stringify(res));

      // EventBus.$on('dataChanged', (newData) => {
      //   console.log('兄弟组件传值',newData);
      //   this.ifShowDept = newData;
      // });

    });
  },
  methods: {
    /**
    * hex:获取到的主题色，opacity:透明度
    */
    hexToRgba(hex, opacity) {
       return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' + parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')'
    },
    toSchool(){
      window.open('https://www.hbmzu.edu.cn/')
    },
    loginFn() {
      // window.open("https://portal.ly-sky.com:7435/swzx/#/login");
      this.$router.push('/login')
    },
    gotoPage(e) {
      window.open(e);
    },
    changeUrl(url, idx, val) {
      // this.$router.push(e);
      sessionStorage.setItem("naviId", val.id);
      if(val.classify == 1){
        if(url == '/detailedList'){
          // this.ifShowDept = true;
        }else{
          // this.ifShowDept = false;
          this.naviIndex = idx;
          this.$router.push(`${url}?naviId=${val.id}`);
        }
      }else{
        window.open(url)
      }
    },
    handleMouseOver(url, idx, val) {  
      sessionStorage.setItem("naviId", val.id);
      this.type = 'mask';
      if (val.classify == 1) {//权责清单
        if(url == '/detailedList'){
          this.ifShowDept = true;
        }
      }
    },
    close(val){
      // console.log(val,'子组件传值');
      this.ifShowDept = val;
    },
    modalFn(val,type){      
      if(val == 2){
        if(this.type != 'mask'){
          this.ifShowDept = false;
        }
      }else{
        this.ifShowDept = true;
      }
      this.type = type;
    },
    logout() {
      let that = this;
      this.$confirm({
        title: "确认退出登录么？",
        okText: "确认",
        cancelText: "取消",
        onOk() {
          // sessionStorage.removeItem("accessToken");
          // that.$router.push('/login')
          // console.log(global.userId);
          // console.log(global.tokenId);
          // console.log(global.orgId);
          let headers = {
            // "userAuthType": "MS"
            'X-Requested-With': 'XMLHttpRequest',
            'gatewayAppId': 'ly-portal-affairs',
            'gatewayserviceid': 'ly-portal-affairs-svc',
            'Authorization': global.tokenId,
            'Loginuserid': global.userId,
            'Loginuserorgid': global.orgId
          }
          logout('', headers).then(e => {
            // console.log('e', e);
          }).catch(res => {
            // console.log(res);
            // sessionStorage.removeItem('ly-portal-affairs-ui-userLogin')
            sessionStorage.clear();
            that.$message.success('登出成功！');
            setTimeout(() => {
              that.$router.push('/login')
            }, 500);
            // window.location = window.casLogoutUrl;
          })
        }
      })

    },
  },
};
</script>

<style lang="less" scoped>
.header {
  box-shadow: 6px 3px 19px 0 rgba(0, 0, 0, 0.1);
  .top {
    justify-content: space-between;
    // padding-top: 24px;
    margin-bottom: 33px;
    .top_head {
      color: #555555;
      font-size: 14px;
      .top_head_box {
        padding: 0 32px;
        position: relative;
        cursor: pointer;
      }
      .pseudo_class::after {
        content: "";
        position: absolute;
        top: 20%;
        right: -3%;
        width: 1px;
        height: 14px;
        background: #555;
        opacity: 0.5;
      }
    }
  }
  .navi {
    height: 138px;
    .nav_ul{
      margin-top: 27px;
      .navi_li {
        font-size: 18px;
        cursor: pointer;
        margin-right: 24px;
        color: var(--themeColor);
        padding: 8px 12px;
      }
    }
    .line_class {
      background: var(--themeColor);
      color: #fff !important;
      border-radius: 8px;
    }
    .logo_top{
      padding-top: 12px;
      justify-content: space-between;
      .top_r{
        font-size: 16px;
        div{
          cursor: pointer;
        }
        .line_ver{
            margin: 0 32px;
            width: 1px;
            height: 14px;
            opacity: 0.5;
            background: #333;
          }
      }
    }
  }
  // .navi div:last-child {
  //   margin-right: 0;
  // }
  .dept_modal{
    position: absolute;
    top: 138px;
    width: 100%;
  }
}
.ant-dropdown-link{
  color: #2c3e50;
  height: 30px;
  line-height: 30px;
}
</style>
